import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = {
  hasError: false,
  hasForbiddenError: false,
}

const storiesSummaryErrorSlices = createSlice({
  name: 'brandLostShopperSummaryError',
  initialState,
  reducers: {
    setStoriesSummaryError(
      state,
      action: PayloadAction<{ hasError: boolean; hasForbiddenError: boolean }>
    ) {
      state.hasError = action.payload.hasError
      state.hasForbiddenError = action.payload.hasForbiddenError
    },
  },
})

export const { setStoriesSummaryError } = storiesSummaryErrorSlices.actions

export default storiesSummaryErrorSlices.reducer
